import { isToday, isYesterday, isWithinInterval, subDays } from "date-fns";
import "react-tooltip/dist/react-tooltip.css";
import utils from "../../business/helper/Utils";
import arrow_down from "../../images/arrow_down.svg";
import List from "../design/History/List";
import star from "../../images/star.svg";

export const MilaHistoricList = ({
  milaHistoric,
  onHistoricItemClick,
  active,
}) => {
  const milaHistoricByDateRange = milaHistoric?.reduce(
    (acc, histo) => {
      const createDate = new Date(histo.createDateUTC);

      if (isToday(createDate)) {
        acc.today.push(histo);
      } else if (isYesterday(createDate)) {
        acc.yesterday.push(histo);
      } else if (
        isWithinInterval(createDate, {
          start: subDays(new Date(), 6),
          end: new Date(),
        })
      ) {
        acc.lastSevenDays.push(histo);
      } else {
        acc.currentMonth.push(histo);
      }

      return acc;
    },
    {
      today: [],
      yesterday: [],
      lastSevenDays: [],
      currentMonth: [],
    }
  );

  return (
    <div>
      {(milaHistoricByDateRange?.today?.length > 0 ||
        milaHistoricByDateRange?.yesterday?.length > 0 ||
        milaHistoricByDateRange?.lastSevenDays?.length > 0 ||
        milaHistoricByDateRange?.currentMonth?.length > 0) && (
          <h3 className="font-semibold mb-2 text-dark-blue-100 text-xl px-1">
            History
          </h3>
        )}
      {milaHistoric && !!milaHistoric.length && (
        <div className="scrollbar-thin">
          {milaHistoricByDateRange.today.length > 0 && (
            <List
              items={milaHistoricByDateRange.today}
              prefixKey="histo_today_"
              onHistoricItemClick={onHistoricItemClick}
              header={"Today"}
              active={active}
            />
          )}

          {milaHistoricByDateRange.yesterday.length > 0 && (
            <List
              items={milaHistoricByDateRange.yesterday}
              prefixKey="histo_yesterday_"
              onHistoricItemClick={onHistoricItemClick}
              header={"Yesterday"}
              active={active}
            />
          )}

          {milaHistoricByDateRange.lastSevenDays.length > 0 && (
            <List
              items={milaHistoricByDateRange.lastSevenDays}
              prefixKey="histo_last_seven_"
              onHistoricItemClick={onHistoricItemClick}
              header={"Last 7 Days"}
              active={active}
            />
          )}

          {milaHistoricByDateRange.currentMonth.length > 0 && (
            <List
              items={milaHistoricByDateRange.currentMonth}
              prefixKey="histo_current_month_"
              onHistoricItemClick={onHistoricItemClick}
              header={"Last 30 Days"}
              active={active}
            />
          )}
        </div>
      )}
    </div>
  );
};
